exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".web-components-___Page__page___14mKH{padding:2em;background-color:#fff;border:1px solid #e5e3e3}@media (max-width:599px){.web-components-___Page__page___14mKH{border:none;border-top:1px solid #e5e3e3;border-bottom:1px solid #e5e3e3}}", ""]);

// exports
exports.locals = {
	"page": "web-components-___Page__page___14mKH"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?importLoader=1&modules&localIdentName=[path]___[name]__[local]___[hash:base64:5]&?minimize=true!./web/components/Page.css
// module id = 1331
// module chunks = 0